import { html } from "lit";

export const comparisonTeaserData = {
    text: "Digitale Anleitungen und hinterlegte Parametertabellen erleichtern die Arbeit an den Maschinen.",
};
export const comparisonTeaserData2 = {
    text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat. Lorem amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.",
};

export const TeaserComparison = (
    args = comparisonTeaserData,
    gridClass
) => html`
    <div class="ux-iws-teaser-comparison ${gridClass}">
        <ux-iws-link-wrapper>
            <div
                class="ux-u-shadow ux-u-h-100 ux-u-d-flex ux-u-flex-dir-column"
            >
                <div class="ux-iws-teaser-universal__media">
                    <img src="./mock-assets/images/comparison.jpg" alt="" />
                </div>
                <div
                    class="ux-u-p-xs ux-u-d-flex ux-u-flex-dir-column ux-u-flex-jc-between ux-u-h-100"
                >
                    <div class="ux-u-text-align--left">
                        <div class="ux-iws-teaser-comparison__title">
                            Fachkräftemangel
                        </div>
                        <div class="ux-iws-teaser-comparison__sub-title">
                            Integriertes Know-how
                        </div>
                        <div class="ux-iws-teaser-comparison__text">
                            <p>${args.text}</p>
                        </div>
                    </div>
                </div>
            </div>
        </ux-iws-link-wrapper>
    </div>
`;

export const TeaserComparisonTemplate = (args) => {
    return TeaserComparison(args, "");
};
